import type { ResearchStudy, StudyField, StudyType } from "@/lib/research/types";

export interface StudyFilterCriteria {
	/** Keep a study if its type is in this array. Empty array or undefined = no type filter. */
	types?: StudyType[];
	/** Keep a study if its fields array shares at least one element with this array. Empty/undefined = no field filter. */
	fields?: StudyField[];
	/** Keep a study whose peptideSlugs array includes this slug. Undefined = no peptide filter. */
	peptideSlug?: string;
	/** When true, keep only studies with human === true. false/undefined = no human filter. */
	humanOnly?: boolean;
}

/**
 * Pure function: filters studies by all provided criteria combined with AND logic.
 * An undefined or empty criterion does not filter anything out.
 */
export function filterStudies(studies: ResearchStudy[], criteria: StudyFilterCriteria): ResearchStudy[] {
	const { types, fields, peptideSlug, humanOnly } = criteria;

	const filterByTypes = types !== undefined && types.length > 0;
	const filterByFields = fields !== undefined && fields.length > 0;
	const filterByPeptide = peptideSlug !== undefined;
	const filterByHuman = humanOnly === true;

	return studies.filter((study) => {
		if (filterByTypes && !types.includes(study.type)) {
			return false;
		}
		if (filterByFields && !study.fields.some((f) => fields.includes(f))) {
			return false;
		}
		if (filterByPeptide && !study.peptideSlugs.includes(peptideSlug)) {
			return false;
		}
		if (filterByHuman && !study.human) {
			return false;
		}
		return true;
	});
}
